import { Type, inject } from '@angular/core';
import { callApiMethod } from '@kinet-open-network/client/shared/util';
import {
  IMapBounds,
  IMapItem,
} from '@kinet-open-network/shared/data-access/model';
import {
  patchState,
  signalStoreFeature,
  withMethods,
  withState,
} from '@ngrx/signals';
import { Observable } from 'rxjs';
import {
  setError,
  setLoaded,
  setLoading,
  withCallState,
} from './call-state.feature';

type MapItemsState = {
  mapItems: IMapItem[];
};

type MapItemsService = {
  getMapItems(bounds: IMapBounds): Observable<IMapItem[]>;
};

export function withMapItems(Service: Type<MapItemsService>) {
  return signalStoreFeature(
    signalStoreFeature(
      withCallState({ collection: 'mapItems' }),
      withState<MapItemsState>({
        mapItems: [],
      }),
      withMethods((store, service = inject(Service)) => ({
        loadMapItems: async (bounds: IMapBounds) => {
          patchState(store, setLoading('mapItems'));

          return callApiMethod(() => service.getMapItems(bounds), {
            next: (mapItems) =>
              patchState(store, { mapItems }, setLoaded('mapItems')),
            error: (error) => patchState(store, setError(error, 'mapItems')),
          });
        },
      })),
    ),
  );
}
